import { FlowEnum, RouteInterface } from "src/common";
import { PropertyTypePage } from "../propertyType.page";
import { PropertyInfoApartmentPage } from "../propertyInfoApartment.page";
import { PropertyInfoHousePage } from "../propertyInfoHouse.page";
import { CustomerWebshopPage } from "../customerWebshop.page";
import { OffersCheckoutPage } from "../offersCheckout.page";
import { OffersWebshopPage } from "../offersWebshop.page";
import { OfferPreviewPage } from "../offerPreview.page";
import { OfferConfirmationPage } from "../offerConfirmation.page";
import { InsuranceNeedsPage } from "../insuranceNeeds.page";
import { AppRoutes } from "./app.routes";
import CustomerFunnelPage from "../customerFunnel.page";
import { TermsPage } from "../termsAndConditions.page";
import CheckoutPage from "../checkoutPayment.page";
import CheckoutSuccessOfflinePage from "../checkoutSuccessOffline.page";
import CheckoutSuccessGeneralTransferPage from "../checkoutSuccessGeneralTransfer.page";
import CheckoutPaymentSentPage from "../checkoutPaymentSent.page";
import CheckoutSuccessPage from "../checkoutSuccess.page";
import CheckoutFailurePage from "../checkoutFailure.page";
import { ContactPage } from "../contact.page";
import { ContactWebshopPage } from "../contactWebshopTemp.page";

export const AppRouting: Array<RouteInterface> = [
  {
    path: AppRoutes.ROOT,
    element: PropertyTypePage,
    functions: []
  },
  {
    path: AppRoutes.WEBSHOP.CUSTOMER,
    element: CustomerWebshopPage,
    functions: [],
    pageName: 'Osnovni podaci'
  },
  {
    path: AppRoutes.FUNNEL.CUSTOMER,
    element: CustomerFunnelPage,
    functions: [],
    pageName: 'Osnovni podaci'
  },
  {
    path: AppRoutes.PROPERTY_TYPE,
    element: PropertyTypePage,
    functions: [],
    pageName: 'Vrsta nekretnine'
  },
  {
    path: AppRoutes.WEBSHOP.PROPERTY_INFO,
    element: PropertyInfoApartmentPage,
    functions: [],
    pageName: 'Detalji nekretnine - Stan'
  },
  {
    path: `${AppRoutes.WEBSHOP.PROPERTY_INFO}/so/:soId`,
    element: PropertyInfoApartmentPage,
    functions: [],
    pageName: 'Detalji nekretnine - Stan - povratni link'
  },
  {
    path: AppRoutes.FUNNEL.RISKS,
    element: InsuranceNeedsPage,
    functions: [],
    pageName: 'Detalji o rizicima',
    props: {
      backwardPath: AppRoutes.PROPERTY_TYPE,
      forwardPath: AppRoutes.FUNNEL.PROPERTY_INFO,
      flow: FlowEnum.FUNNEL
    }
  },
  {
    path: AppRoutes.WEBSHOP.RISKS,
    element: InsuranceNeedsPage,
    functions: [],
    pageName: 'Detalji o rizicima',
    props: {
      backwardPath: AppRoutes.WEBSHOP.CUSTOMER,
      forwardPath: AppRoutes.WEBSHOP.OFFERS,
      flow: FlowEnum.WEBSHOP
    }
  },
  {
    path: AppRoutes.FUNNEL.PROPERTY_INFO,
    element: PropertyInfoHousePage,
    functions: [],
    pageName: 'Detalji nekretnine - Kuća'
  },
  {
    path: `${AppRoutes.FUNNEL.PROPERTY_INFO}/so/:soId`,
    element: PropertyInfoHousePage,
    functions: [],
    pageName: 'Detalji nekretnine - Kuća - povratni link'
  },
  {
    path: AppRoutes.WEBSHOP.OFFERS,
    element: OffersWebshopPage,
    functions: [],
    pageName: 'Ponude'
  },
  {
    path: AppRoutes.WEBSHOP.OFFER,
    element: OfferPreviewPage,
    functions: [],
    pageName: 'Detalji ponude'
  },
  {
    path: AppRoutes.WEBSHOP.OFFER_CONFIRMATION,
    element: OfferConfirmationPage,
    functions: [],
    pageName: 'Potvrda podataka',
    props: {
      bannerData: 'full_details',
      backwardPath: AppRoutes.WEBSHOP.OFFER,
      forwardPath: AppRoutes.WEBSHOP.PAYMENT
    }
  },
  {
    path: AppRoutes.WEBSHOP.PAYMENT,
    element: CheckoutPage,
    functions: [],
    pageName: 'Plaćanje',
    props: {
      bannerData: 'full_details',
      backwardPath: AppRoutes.WEBSHOP.OFFER_CONFIRMATION,
      forwardPath: AppRoutes.WEBSHOP.CHECKOUT_FAILURE
    }
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_SUCCESS,
    element: CheckoutSuccessPage,
    functions: [],
    pageName: 'Plaćanje uspješno'
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_FAILURE,
    element: CheckoutFailurePage,
    functions: [],
    pageName: 'Plaćanje neuspjeh',
    props: {
      backwardPath: AppRoutes.WEBSHOP.OFFER_CONFIRMATION,
      forwardPath: AppRoutes.WEBSHOP.PAYMENT
    }
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_SUCCESS_OFFLINE,
    element: CheckoutSuccessOfflinePage,
    functions: [],
    pageName: 'Plaćanje uspjeh (offline)'
  },
  {
    path: AppRoutes.TERMS_AND_CONDITIONS,
    element: TermsPage,
    functions: [],
    pageName: 'Uvjeti osiguranja'
  },
  {
    path: AppRoutes.FUNNEL.CONTACT,
    element: ContactPage,
    functions: [],
    pageName: 'Kontaktirati će te agent'
  },
  {
    path: AppRoutes.WEBSHOP.CONTACT,
    element: ContactWebshopPage,
    functions: [],
    pageName: 'Kontaktirati će te agent'
  },
  {
    path: AppRoutes.CHECKOUT.OFFERS,
    element: OffersCheckoutPage,
    functions: [],
    pageName: 'Ponude',
    props: {
      bannerData: 'property_details',
    }
  },
  {
    path: AppRoutes.CHECKOUT.OFFER_CONFIRMATION,
    element: OfferConfirmationPage,
    functions: [],
    pageName: 'Potvrda Podataka',
    props: {
      bannerData: 'full_details',
      backwardPath: AppRoutes.CHECKOUT.OFFERS,
      forwardPath: AppRoutes.CHECKOUT.PAYMENT
    }
  },
  {
    path: AppRoutes.CHECKOUT.PAYMENT,
    element: CheckoutPage,
    functions: [],
    pageName: 'Plaćanje',
    props: {
      bannerData: 'full_details',
      backwardPath: AppRoutes.CHECKOUT.OFFER_CONFIRMATION,
      forwardPath: AppRoutes.CHECKOUT.CHECKOUT_FAILURE,
    }
  },
  {
    path: AppRoutes.CHECKOUT.CHECKOUT_SUCCESS_OFFLINE,
    element: CheckoutSuccessOfflinePage,
    functions: [],
    pageName: 'Plaćanje uspjeh (offline)',
  },
  {
    path: AppRoutes.CHECKOUT.CHECKOUT_SUCCESS_GENERAL_TRANSFER,
    element: CheckoutSuccessGeneralTransferPage,
    functions: [],
    pageName: 'Plaćanje - opća uplatnica'
  },
  {
    path: AppRoutes.CHECKOUT.GENERAL_TRANSFER_PAYMENT_SENT,
    element: CheckoutPaymentSentPage,
    functions: [],
    pageName: 'Plaćanje - podaci za uplatu'
  },
  {
    path: AppRoutes.CHECKOUT.CHECKOUT_SUCCESS,
    element: CheckoutSuccessPage,
    functions: [],
    pageName: 'Plaćanje uspješno'
  },
  {
    path: AppRoutes.CHECKOUT.CHECKOUT_FAILURE,
    element: CheckoutFailurePage,
    functions: [],
    pageName: 'Plaćanje neuspjeh',
    props: {
      backwardPath: AppRoutes.CHECKOUT.OFFER_CONFIRMATION,
      forwardPath: AppRoutes.CHECKOUT.PAYMENT
    }
  },
  {
    path: AppRoutes.WEBSHOP.CHECKOUT_SUCCESS_OFFLINE,
    element: CheckoutSuccessOfflinePage,
    functions: [],
    pageName: 'Plaćanje uspjeh (offline)'
  },
];
